import axiosInstance from '../../utils/https';
import {
    ALL_ADMIN_DOCUMENTS_SERVICE_MANAGEMENT,
    ALL_ADMIN_EVIDENCE_BY_SERVICE_MANAGEMENT,
    ALL_EXEMPTED_EVIDENCE,
    ALL_SERVICE_MANAGEMENT,
    ALL_SERVICE_MANAGEMENT_METRICS,
} from '../constants';

//SOC2
export const GetAllServiceManagement = () => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/service_mgt/?parent_service=false`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ALL_SERVICE_MANAGEMENT, payload: res?.data });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const CreateServiceManagement = (credentials) => async (dispatch) => {
    try {
        const res = await axiosInstance().post(`/compliance/service_mgt/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllServiceManagement());
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const EditServiceManagement = (credentials, control_id) => async (dispatch) => {
    try {
        const res = await axiosInstance().patch(`/compliance/service_mgt/${control_id}/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllServiceManagement());
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const DeleteServiceManagement = (control_id) => async (dispatch) => {
    try {
        const res = await axiosInstance().delete(`/compliance/service_mgt/${control_id}/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllServiceManagement());
        return {
            success: true,
            message: 'Deleted Successful.',
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const GetServiceManagementMetrics = (merchant) => async (dispatch, getState) => {
    const user_type = getState().authReducers.user_type;
    const company_id = user_type === 'auditor' ? merchant : getState().authReducers?.company_id;
    const needsID = getState().authReducers?.user_type === 'admin' || getState().authReducers?.user_type === 'auditor';
    try {
        const res = needsID
            ? await axiosInstance().get(`/compliance/iso20000_get_summary/?merchant_id=${company_id}`)
            : await axiosInstance().get(`/compliance/iso20000_get_summary/`);

        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ALL_SERVICE_MANAGEMENT_METRICS, payload: res?.data });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};

export const GetDocumentsServiceManagement = (subcontrol) => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/documents/?service_mgt=${subcontrol}&tags=iso20000`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({
            type: ALL_ADMIN_DOCUMENTS_SERVICE_MANAGEMENT,
            payload: res?.data,
        });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const GetEvidencesByServiceManagement = (control) => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/evidence/?service_mgt=${control}&tags=iso20000`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({
            type: ALL_ADMIN_EVIDENCE_BY_SERVICE_MANAGEMENT,
            payload: res?.data,
        });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

//Exempted evidence
export const GetAllExemptedEvidence = (merchant) => async (dispatch, getState) => {
    const user_type = getState().authReducers?.user_type;
    const company_id = user_type === 'auditor' ? merchant : getState().authReducers?.company_id;
    const needsID = getState().authReducers?.user_type === 'admin' || getState().authReducers?.user_type === 'auditor';
    try {
        const res = needsID
            ? await axiosInstance().get(`/compliance/module_exempted/?merchant=${company_id}`)
            : await axiosInstance().get(`/compliance/module_exempted/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ALL_EXEMPTED_EVIDENCE, payload: res?.data });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};

export const ExemptEvidence = (credentials, merchant) => async (dispatch, getState) => {
    const company_id = getState().authReducers?.company_id;
    try {
        const res = await axiosInstance().post(`/compliance/evidence_exempted/`, {
            ...credentials,
            merchant: company_id,
        });
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllExemptedEvidence(merchant));
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};
